import * as React from "react"
import { Box } from "@mui/material"
import { AmchartSeeker, ModalSeeker } from "@ui-seeker/core"

import { useShareOfSearchEvolutionData } from "./@hooks"
import ShareOfSearchKeywordEvolutionChartToolbar from "./Toolbar"


export default function ShareOfSearchKeywordEvolutionChart() {

    const {
        dataEvolution, dataEvolutionKeys,skuName, isLoadingDataEvolution,
        resetEvolutionData, chartColors, dateRange, onChange } = useShareOfSearchEvolutionData()
    
    if (!dataEvolution?.length || isLoadingDataEvolution) return <></>

    const statusLabels = {
		'Stock': 'Stock',
		'Out Of Stock': 'Out Of Stock',
		'Delisted': 'Delisted',
	}
    
    return <ModalSeeker 
        hideActions 
        isOpen={!!dataEvolution?.length} 
        title={`Position & Stock Evolution - ${skuName}`} 
        controller={() => resetEvolutionData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <AmchartSeeker
            data={dataEvolution}
            title={<Box id="evolution-chart"></Box>}
            pdfProps={{
                titlePDF:`Position & Stock Evolution - ${skuName}`
            }}
            series={[
                {
                    name: "Position",
                    yField: "position",
                    xField: "date",
                    type: "line",
                    connect: true,
                    tooltip: {
                        labelText: "[bold]Position: {valueY}[/]",
                    },
                },
                ...(dataEvolutionKeys.map(key => ({
                name: statusLabels[key],
                yField: key,
                xField: "date",
                color: chartColors[key],
                    strokes: {
                        strokeDasharray: [0, 100000]
                    },
                    bullets: { 
                        hidden: false, 
                        radius: 10,
                        fill: chartColors[key]
                    },
                tooltip: {
                    labelText: "[bold]{statusLabel}"
                }
            })))]}
            chartProps={{
                numberFormat: `#`,
                dateFormatReceived: 'yyyyMMdd',
                xAxis: {
                    categoryField: 'date',
                    isDateAxis: true,
                    dateFormat: 'dd MMM yyyy',
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    }
                }
            }}
            cardProps={{ actions: <ShareOfSearchKeywordEvolutionChartToolbar dateRange={dateRange} onChange={onChange}/> }}
            sx={{ height: 500 }}
        />
    </ModalSeeker>
}